/*
  When payment terms modal is opened, close open quickview to fix stacking issue
*/

(() => {
  let openLooxQuickviewEl = null;
  const selector = '.loox-overlay';
  let targetElement = document.querySelector(selector);

  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {

      // 1. Check for ENTERS (Elements added to the DOM)
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          if (node.matches(selector) || node.querySelector(selector)) {
            targetElement = node.matches(selector) ? node : node.querySelector(selector);
            const openQuickview = document.querySelector('[data-quickview-menu][open]');
            if (openQuickview) {
              openLooxQuickviewEl = openQuickview.closest('quick-view');
              openLooxQuickviewEl.close();
            }
          }
        }
      });

      // 2. Check for LEAVES (Elements removed from the DOM)
      mutation.removedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          if (node === targetElement || node.contains(targetElement)) {
            targetElement = null;
            if (openLooxQuickviewEl) {
              openLooxQuickviewEl.open();
              openLooxQuickviewEl = null;
            }
          }
        }
      });
    }
  });

  // Start observing the entire document
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();
